import React, { useEffect } from 'react'
import { navigate } from 'gatsby'
import TopContent from '../components/organisms/topContent/topContent'
import PageLayout from '../components/templates/page-layout/page-layout'
import useMediaQuery from '../utils/useMediaQuery'

const Top = () => {
  const isMobile = useMediaQuery()

  // useEffect(() => {
  //   navigate('/')
  // })

  return (
    <PageLayout>
      {/*<h1>No deberías de estar aquí.</h1>*/}
       <TopContent isMobile={isMobile} />
    </PageLayout>
  )
}

export default Top
